export const isDocumentVerificationRequired = (selectedGroup, isDocumentVerified) => {
  let isDocumentVerificationRequired = false;
  if (selectedGroup.documentVerification) {
    if (selectedGroup !== null && selectedGroup !== void 0 && selectedGroup.documentVerificationCompleteChecks && isDocumentVerified === "match") {
      isDocumentVerificationRequired = false;
    } else {
      isDocumentVerificationRequired = true;
    }
  }
  return isDocumentVerificationRequired;
};
export const extraInfoDetails = practiceGroup => {
  const {
    completedChecks,
    totalChecks
  } = practiceGroup;
  let extraInfoDetails = null;
  const pendingChecks = Math.max(0, totalChecks - completedChecks);
  const isChecksCompleted = totalChecks > 0 && pendingChecks === 0;
  const hasChecks = totalChecks > 0;
  if (hasChecks) {
    extraInfoDetails = isChecksCompleted ? "completed" : "not-completed";
  }
  return extraInfoDetails;
};
export const getMemberDetailsStatus = (practiceGroup, isNotStartedTab = false) => {
  const {
    completedChecks,
    totalChecks
  } = practiceGroup;
  const hasChecks = totalChecks > 0;
  const pendingChecks = Math.max(0, totalChecks - completedChecks);
  if (!hasChecks) {
    return null;
  }
  return pendingChecks === 0 ? "complete" : `${pendingChecks} to do`;
};
export const getPracticeQuestionStatus = (practiceGroup, isNotStartedTab = false) => {
  const {
    totalQuestionAssigned,
    completedByExpertTotal
  } = practiceGroup;
  const pendingPracticeQuestions = Math.max(0, totalQuestionAssigned - completedByExpertTotal);
  const shouldPracticeTaskVisible = totalQuestionAssigned > 0;
  if (!shouldPracticeTaskVisible) {
    return null;
  }
  return pendingPracticeQuestions === 0 ? "complete" : `${pendingPracticeQuestions} to do`;
};
export const shouldPracticeTaskVisible = practiceGroup => (practiceGroup === null || practiceGroup === void 0 ? void 0 : practiceGroup.totalQuestionAssigned) > 0;
export const isRedChip = value => {
  const normalized = value === null || value === void 0 ? void 0 : value.toString().toLowerCase().trim();
  return (normalized === null || normalized === void 0 ? void 0 : normalized.includes("left")) || normalized === "to do";
};